enum TagId {
  EVCredit = 116,
  GreatDeal = 104,
  PriceDrop = 103
}

export default TagId;
